import {scopedHandler} from 'utils/redux';
import ns from './namespace';
import initState from './state';
import * as actions from './actions';
import * as effects from './effects';
import {decorateHandler as lifecycle} from 'fragments/lifecycle';

const handler = scopedHandler(ns, (state = initState, fullState, {type, payload}) => {
	switch (type) {
		case actions.initialize.type: {
			return [state, effects.initialize()];
		}

		case actions.destroy.type: {
			return [initState, null];
		}

		case actions.getSmsLogs.type: {
			return [
				{
					...state,
					processing: true,
				},
				effects.getSmsLogs(payload),
			];
		}

		case actions._getSmsLogs.type: {
			return [
				{
					...state,
					processing: false,
					smsLogs: payload,
				},
				null,
			];
		}

		case actions._getUsers.type: {
			return [
				{
					...state,
					users: payload,
				},
				null,
			];
		}

		default:
			return [state, null];
	}
});

export default lifecycle({
	namespace: ns,
	initializeType: actions.initialize.type,
	destroyType: actions.destroy.type,
})(handler);
